import { IPhotoDetails } from '@/app/models/photo'
import { SavePictureActions } from '../actions/save-picture'

export const SAVE_PICTURE_REDUCER_NAMESPACE = 'savePictureReducer'

export interface SavePictureState {
    photoDetails: IPhotoDetails
}

const defaultState: SavePictureState = {
    photoDetails: null,
}

export default (state = defaultState, action) => {
    switch (action.type) {
        case SavePictureActions.SET_PHOTO_DETAILS:
            return {
                ...state,
                photoDetails: action.payload,
            }
        default:
            return state
    }
}
